import dayjs from 'dayjs';

// format to De locale
export const formatDateToGerman = (date: Date) => {
  dayjs.locale('de');
  return dayjs(date).format('DD.MM.YYYY');
};
